module.exports = __webpack_public_path__ + "img/77376.c697069d.svg";